export default __webpack_public_path__ + "static/media/comparison-nova-sm.53596184.jpg";